import CryptoJS from 'crypto-js';

const sharedSecret = process.env.REACT_APP_FRONT_SHARED_KEY;

export function decryptFromBackend(encoded: string): string {
  if (!encoded) {
    throw new Error('No payload provided for decryption');
  }

  if (!sharedSecret) {
    throw new Error('VITE_FRONT_SHARED_KEY is not defined in the environment');
  }

  const normalised = encoded.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalised.padEnd(normalised.length + ((4 - (normalised.length % 4)) % 4), '=');
  const raw = CryptoJS.enc.Base64.parse(padded);

  if (raw.sigBytes < 17) {
    throw new Error('Encrypted payload is too short to contain IV and data');
  }

  const iv = CryptoJS.lib.WordArray.create(raw.words.slice(0, 4), 16);
  const cipherWords = raw.words.slice(4);
  const ciphertext = CryptoJS.lib.WordArray.create(cipherWords, raw.sigBytes - 16);

  const hashHex = CryptoJS.SHA256(sharedSecret).toString(CryptoJS.enc.Hex);
  const truncatedHex = hashHex.slice(0, 32);
  const key = CryptoJS.enc.Utf8.parse(truncatedHex);

  const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
}
